// Функция приводящая
// CamelCase в camel-case
// camelCase в camel-case

const getKebabCase = (string: string): string => string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

export default getKebabCase;
